import { faLoader } from '@awesome.me/kit-f3dc60f0d0/icons/classic/regular';
import {
  faCheckCircle,
  faCircleInfo,
  faExclamationTriangle,
  faQuestionCircle,
  faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

import type { StatusChipVariant } from './types';

// Get variant styles for StatusChip component
export const getVariantStyles = (variant: StatusChipVariant) => {
  switch (variant) {
    case 'success':
      return {
        backgroundColor: 'vai-bg-green-50',
        borderColor: 'vai-border-green-100',
        iconColor: 'vai-text-green-600',
        textColor: 'vai-text-green-800',
        icon: faCheckCircle,
      };
    case 'error':
      return {
        backgroundColor: 'vai-bg-red-50',
        borderColor: 'vai-border-red-100',
        iconColor: 'vai-text-red-600',
        textColor: 'vai-text-red-700',
        icon: faTimesCircle,
      };
    case 'warning':
      return {
        backgroundColor: 'vai-bg-amber-50',
        borderColor: 'vai-border-amber-100',
        iconColor: 'vai-text-amber-500',
        textColor: 'vai-text-amber-700',
        icon: faExclamationTriangle,
      };
    case 'ghost':
      return {
        backgroundColor: '',
        borderColor: undefined,
        iconColor: 'vai-text-zinc-500',
        textColor: 'vai-text-base-foreground',
        icon: faQuestionCircle,
      };
    case 'progress':
      return {
        backgroundColor: 'vai-bg-blue-50',
        borderColor: 'vai-border-blue-200',
        iconColor: 'vai-text-blue-500',
        textColor: 'vai-text-blue-800',
        icon: faLoader,
      };
    default:
      return {
        backgroundColor: 'vai-bg-zinc-100',
        borderColor: 'vai-border-zinc-300',
        iconColor: 'vai-text-zinc-500',
        textColor: 'vai-text-zinc-600',
        icon: faCircleInfo,
      };
  }
};
